import React from 'react'
import queryString from 'query-string'
import { Link, } from 'react-router-dom'

export default function SubjectNavLink({ subtest, uAid, query, activeSubtest, reportsRoute }) {
  let q = '', qsObj
  const active = subtest.setId === activeSubtest
  if (query) {
    qsObj = Object.assign({}, query)
    if (qsObj.nd && !active) {
      delete qsObj.nd
    }
  }
  query ? q = `?${queryString.stringify(qsObj)}` : null
  const path = `/assessment/${reportsRoute ? 'reports' : 'testing'}/${uAid}/${subtest.setId}${q}`
  return (
    <li className={active ? 'subject-nav-link-active' : ''}>
      <Link to={path}>
        {subtest.displayName}
      </Link>
    </li>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessTest/SubjectNavLink.js